(() => {
  if (window.lookbookShopInitialized) return;
  window.lookbookShopInitialized = true;

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.lookbook-shop__form select[name="id"]');
    if (!select) return;

    const form = select.closest('form');
    if (!form) return;
    const submit = form.querySelector('[type="submit"]');

    if (submit) {
      submit.disabled = !select.value;
      submit.textContent = submit.dataset.lookbookAddLabel;
    }
  });

  document.addEventListener('variant:add', (event) => {
    const drawer = event.target.closest('.lookbook-shop__drawer');
    if (drawer) drawer.dispatchEvent(new CustomEvent('dialog:force-close', { bubbles: true }));
  });
})();
